import { WebAppUtils, FeedbackManager, RecaptchaManager, DefaultCookieControlManager } from "flowli.web.common.client";

import { TabComponent } from './TabComponent/TabComponent'
import { Pagination } from './Pagination'
import { AccountManager } from './AccountManager'
import "foundation-datepicker";
import "readmore-js";
import { Utils } from './Utils';

export class Application {

    public Tabs: { [key: string]: TabComponent };
    public Paginations: { [key: string]: Pagination };
    public AccountManager: AccountManager;

    public Init() {
        this.SetupValidation();
        this.SetupReadMore();
        this.Tabs = {};

        $("ul[role=tablist]").each((i: number, elt: HTMLElement) => {
            var tab = new TabComponent(this, $(elt));
            this.Tabs[tab.Id] = tab;
        });

        $(".login-tabs").each((i: number, elt: HTMLElement) => {
            var tab = new TabComponent(this, $(elt));
            this.Tabs[tab.Id] = tab;
        });

        this.Paginations = {};

        $(".paginator").each((i: number, elt: HTMLElement) => {
            var pagination = new Pagination(this, $(elt));
            this.Paginations[pagination.Id] = pagination;
            if (pagination.Id.indexOf("-commentaries") > 0) {
                pagination.OnPageChanged = () => {
                    this.SetupPublishedDatePickers();
                };
            }

        });

        if (window.location.href.indexOf("/cache") > -1) {
            (async () => {
                const { cacheManager } = await import('flowli.web.common.client');
                cacheManager.Init();
            })();
        }

        $(".select-select2").select2();

        $(".matchheight").matchHeight();


        if (window.location.href.toLowerCase().indexOf("/author") > 0 || window.location.href.toLowerCase().indexOf("/dashboard") > 0) {
            this.SetupFilterControls();

        }

        if (window.location.search == "?expanded") {
            var $serieCaller = $(window.location.hash + " .expandable-caller");
            if ($serieCaller.length) {
                this.ToggleFilterControl($serieCaller);
            }
        };

        this.SetupPublishedDatePickers();

        if (window.location.pathname === "/") {
            this.SetupFeedback();
            this.SetupProspectus();
        }

        $(".anchorlink").click((e: JQuery.ClickEvent) => {
            let hash = $(e.currentTarget).prop("hash");
            if (hash) {
                $(hash).click();
            }
        });

        $(".expandable-caller").click((ev: JQuery.ClickEvent) => {
            ev.stopImmediatePropagation();
            ev.preventDefault();
            var $btn = $(ev.target);
            this.ToggleFilterControl($btn);
        });

        this.AccountManager = new AccountManager(this);
        this.AccountManager.Init();

        const cookieManager = new DefaultCookieControlManager(window["CookieControlResources"],
            ["JSESSIONID", "PHPSESSID", "piwik_ignore", "MATOMO_SESSID", "mtm_consent", "mtm_cookie_consent", "_pk_testcookie", "pendingProductOrder", "ps_checkout_stage",
                "*InteractedMessages*", "fl_member_info", "purchasedSubscriptions", "rwbypass", "ps_messages_ignored"],
            ['_ga', '_gid', '_gat', '__utma', '__utmt', '__utmb', '__utmc', '__utmz', '__utmv', '_matherSegments', '_pk*', "IpLocation", "ai_user", "ai_session", "_sp*"],
            [],
            []);
        cookieManager.Init();
    }

    public SetupValidation() {


        var validateUserInputForm = $(".user-input-form");
        //iterate through the forms in case there are multiple ones on a page
        validateUserInputForm.each((i: number, form: Element) => {
            var $form = $(form);
            var $validation = $form.validate({
                ignore: ":hidden:not(input[type='file'])",
                highlight(element) {
                    $(element).addClass("error");
                    $(element).removeClass("success");
                },
                unhighlight(element) {
                    $(element).removeClass("error");
                    $(element).addClass("success");
                },
                errorPlacement(error, element) {
                    if (element.prev(".validation").length) {
                        error.insertBefore(element.prev(".validation"));
                    } else {
                        error.insertBefore(element);
                    }
                },
                rules: {
                    lastname: {
                        required: true
                    },
                    firstname: {
                        required: true
                    },
                    email: {
                        required: true,
                        email: true
                    },
                    website: {
                        required: true,
                        url: true
                    },
                    password: {
                        required: true,
                        minlength: 6
                    },
                    "password-confirmation": {
                        required: true,
                        minlength: 6,
                        equalTo: "#password"
                    },
                    friendname: {
                        required: true
                    },

                    friendemail: {
                        required: true,
                        email: true
                    },
                    attachments: {
                        required: true
                    },
                    CCMonth: {
                        required: true,
                        digits: true,
                        minlength: 2
                    },
                    CCYear: {
                        required: true,
                        digits: true,
                        minlength: 2
                    },
                    comment: {
                        required: true
                    }
                },
                messages: {
                    firstname: {
                        required: "Please enter your first name"
                    },
                    lastname: {
                        required: "Please enter your last name"
                    },
                    email: {
                        required: "Please provide your email address",
                        email: "Please enter a valid email address"
                    },
                    website: {
                        url: "Please enter a valid URL."
                    },
                    password: {
                        required: "Please provide a password",
                        minlength: "Your password must be at least 6 characters long."
                    },
                    "password-confirmation": {
                        required: "Please confirm your password",
                        minlength: "Your password must be at least 6 characters long.",
                        equalTo: "Please enter the same password as above"
                    },

                    yourname: {
                        required: "Please enter your name."
                    },

                    friendname: {
                        required: "Please enter your friend's name."
                    },

                    friendemail: {
                        required: "Please provide your friend's email address",
                        email: "Please enter a valid email address"
                    },

                    emailsubject: {
                        required: "Please enter the subject of your request."
                    },

                    body: {
                        required: "Please provide more details about your request."
                    },

                    phone: {
                        required: "Please enter a phone number."
                    },

                    organisation: {
                        required: "Please enter an organization or educational institution."
                    },
                    attachments: {
                        required: "Please add an attachment."
                    },
                    CCYear: {
                        required: "Please enter a year.",
                        digits: "Please enter the expiration year in numbers"
                    },
                    CCMonth: {
                        required: "Please enter a month.",
                        digits: "Please enter the expiration month in numbers"
                    },
                    comment: {
                        required: "Please enter your comment text"
                    }
                },
                validClass: "success",
                submitHandler(form) {
                    form.submit(); //submit it the form
                }
            });

            $form.find("input[type=reset]").click((e: JQuery.ClickEvent) => {
                $validation.resetForm();
            });

        });

        this.UpdateFormsToken();
    }

    private SetupProspectus() {
        var $form = $("#request-prospectus-form-container");
        this.SetupFormCaptcha($form);

        $("#SubmitProspectusRequest").click((ev: JQuery.ClickEvent) => {
            ev.stopImmediatePropagation();
            ev.preventDefault();

            this.SubmitContactForm($form, "#prospectus_message", "/request-prospectus");
        });
    }

    private SetupFeedback() {

        var $form = $("#contactform");
        this.SetupFormCaptcha($form);

        $("#SubmitFeedback").click((ev: JQuery.ClickEvent) => {
            ev.stopImmediatePropagation();
            ev.preventDefault();

            this.SubmitContactForm($form, "#feedback_message", "/feedback");
        });
    }

    private SetupFormCaptcha($form: JQuery<HTMLElement>) {
        var $recaptchaDiv = $form.find("div.g-recaptcha");
        if ($recaptchaDiv.length > 0) {
            const recaptchaKey = $("#recaptchaSiteKey").val().toString();
            this.RenderRecaptcha($recaptchaDiv.get(0), recaptchaKey);
        }
    }

    private SubmitContactForm($form: JQuery<HTMLElement>, messageSelector: string, url: string) {

        $form.validate();
        if (!$form.valid()) {
            return;
        }
        var $feedbackmsg = $(messageSelector);
        var recaptchaWidgetId = parseInt($form.find("div.g-recaptcha").attr("data-RecaptchaWidgetId"));
        var captchaResponse = window.grecaptcha.getResponse(recaptchaWidgetId);
        if (captchaResponse.length === 0) {
            $feedbackmsg.html("Please fill in the recaptcha.").addClass("error-alert").removeClass("info-alert");
            return;
        }
        var formElt = <HTMLFormElement>$form.get(0);
        var formData = new FormData(formElt);
        formData.append("CaptchaResponse", captchaResponse);

        $form.addClass("u-loading");
        $.ajax(
            {
                url: url,
                type: "POST",
                data: formData,
                cache: false,
                contentType: false,
                processData: false
            }
        ).done((data: { Success: boolean, Message: string }) => {
            $form.removeClass("u-loading");
            if (data.Success) {
                $feedbackmsg.html(data.Message).removeClass("error-alert").addClass("info-alert");
                formElt.reset();
                window.grecaptcha.reset(recaptchaWidgetId);
            } else {
                $feedbackmsg.html(data.Message).addClass("error-alert").removeClass("info-alert");
            }

        }).fail(() => {
            $form.removeClass("u-loading");
            $feedbackmsg.html("An error occurred while submitting your form").removeClass("error-alert").addClass("info-alert");
        });
    }

    private SetupFilterControls() {
        $(".filter-controls").click((ev: JQuery.ClickEvent) => {
            ev.stopImmediatePropagation();
            ev.preventDefault();
            var $btn = $(ev.target);
            this.ToggleFilterControl($btn);
        });
        $(".filter-run").click((ev: JQuery.ClickEvent) => {
            ev.stopImmediatePropagation();
            ev.preventDefault();
            var $runFilter = $(ev.target);
            var $btnFilter = $("#" + $runFilter.data("filter-button"));
            this.RunFilter($runFilter).done(() => {
                this.ToggleFilterControl($btnFilter);

            });
        });

        $(".filter-close").click((ev: JQuery.ClickEvent) => {
            ev.stopImmediatePropagation();
            ev.preventDefault();
            var $closeFilter = $(ev.target);
            var $btnFilter = $("#" + $closeFilter.data("filter-button"));
            this.ToggleFilterControl($btnFilter);
        });

        $(".filter-clear").click((ev: JQuery.ClickEvent) => {
            ev.stopImmediatePropagation();
            ev.preventDefault();
            var $form = $(ev.target).closest("form");
            this.ClearFilter($form);
        });

        $(".filter-reset").click((ev: JQuery.ClickEvent) => {
            ev.stopImmediatePropagation();
            ev.preventDefault();
            var $form = $("#" + $(ev.target).data("filter-form"));
            this.ClearFilter($form);
            this.RunFilter($form.find(".filter-run"));
        });


        $(".author-select2").select2({
            ajax: {
                url: "/findauthor",
                dataType: 'json',
                // Additional AJAX parameters go here; see the end of this chapter for the full code of this example
                processResults: (data) => {
                    return {
                        results: data,
                        pagination: {
                            more: false
                        }
                    };
                },
                delay: 250
            },
            placeholder: "Start typing the author's lastname"
        });

        this.SetupDatePickers("input.datepick");
    }

    private ClearFilter($form: JQuery) {
        $form.find("input[name=PublishedFrom]").val("");
        $form.find("input[name=PublishedTo]").val("");
        $form.find("select[name=Authors]").val(null).trigger('change');
        $form.find("select[name=Languages]").val(null).trigger('change');
        $form.find("select[name=ContractTypes]").val(null).trigger('change');
        $form.find("select[name=Series]").val(null).trigger('change');
    }

    private RunFilter($runFilter: JQuery): JQueryPromise<boolean> {

        var deferred = $.Deferred<boolean>();

        var $form = $runFilter.closest("form");
        var source = $form.data("filter-containerid");
        if (!source) {
            deferred.fail(null);
        }

        var $container = $("#rows-" + source);
        $container.addClass("u-loading");

        $.ajax({
            url: '/filtercommentaries/' + source,
            type: "POST",
            dataType: 'json', // data type
            data: $form.serialize(), // post data || get data
            success: (data: { Data: string, Total: number, EmptyFilter: boolean }) => {
                $container.html(data.Data);
                this.SetupPublishedDatePickers();
                var pagination = this.Paginations["paginator-" + source];
                if (pagination) {
                    pagination.Option.CurrentPage = 1;
                    pagination.Option.Total = data.Total;
                    pagination.Reset();
                }
                var $btnFilter = $("#" + $runFilter.data("filter-button"));
                if (data.EmptyFilter) {
                    $btnFilter.removeClass("active");
                } else {
                    $btnFilter.addClass("active");
                }
                $container.removeClass("u-loading");
                deferred.resolve(true);
            },
            error: (xhr, resp, text) => {
                console.log(xhr, resp, text);
                $container.removeClass("u-loading");
                deferred.fail(null);
            }
        });

        return deferred.promise();
    }

    private ToggleFilterControl($btn: JQuery) {
        if ($btn.attr("aria-expanded") === "false") {
            $btn.attr("aria-expanded", "true");
            $("#" + $btn.attr("aria-controls")).attr("aria-hidden", "false");
        } else {
            $btn.attr("aria-expanded", "false");
            $("#" + $btn.attr("aria-controls")).attr("aria-hidden", "true");
        }

        if ($btn.hasClass("serie-expander")) {
            var hash = "#" + $btn.attr("aria-controls").slice(3);
            if (hash) {
                this.ScrollTo(hash, 500);
            }
        }
    }

    private SetupReadMore() {

        $(".truncate").readmore({
            speed: 75,
            lessLink: '<button class="read-less">Read less</button>',
            moreLink: '<button class="read-more">Read more</button>',
            collapsedHeight: 50,
            embedCSS: false
        });
    }

    private SetupDatePickers(cssSelector: string): JQuery {

        var $datepicker = $(cssSelector);
        if ($datepicker.length) {
            return $datepicker.fdatepicker({
                weekStart: 1,
                format: 'dd/mm/yyyy',
                disableDblClickSelection: true,
                leftArrow: '<<',
                rightArrow: '>>',
                closeIcon: 'X',
                closeButton: false
            });
        }
        return null;
    }

    private SetupPublishedDatePickers() {

        var $datepicker = this.SetupDatePickers("time.datepick");

        if ($datepicker != null) {
            $datepicker.on("changeDate", (ev: Event) => {
                var $target = $(ev.target);
                var date: string = $target.data("date");
                var commentary = $target.data("commentary");
                var $container = $target.closest("ol");
                var reg = new RegExp("/", 'g');
                // Call backend to update the date;
                $container.addClass("u-loading");
                $.ajax({
                    url: '/setpublisheddate/' + commentary + "/" + date.replace(reg, ""),
                    type: "PUT",
                    dataType: 'json', // data type
                    success: (result) => {
                        if (result.Success) {
                            $target.text(date);
                            $target.removeClass("icon--download").removeClass("ico-after");
                        }
                        $target.fdatepicker("hide");
                        $container.removeClass("u-loading");
                    },
                    error: (xhr, resp, text) => {
                        console.log(xhr, resp, text);
                        $target.fdatepicker("hide");
                        $container.removeClass("u-loading");
                    }
                });
            });
        }
    }

    private RenderRecaptcha(e: Element, recaptchaKey: string) {
        try {
            if (!window.grecaptcha || !window.grecaptcha.render) {
                return;
            }
            var $e = $(e);
            if (!$e.attr("data-RecaptchaWidgetId")) {
                var params: ReCaptchaV2.Parameters = { "sitekey": recaptchaKey };
                var recaptchaWidgetId = window.grecaptcha.render((e) as HTMLElement, params);
                $e.attr("data-RecaptchaWidgetId", recaptchaWidgetId + "");
            }
        } catch (e) {
            console.log(e);
        }
    }

    private ScrollTo(selector: string, duration: number) {

        $('html, body').stop(true).animate({ scrollTop: $(selector).offset().top }, duration);
    }

    private UpdateFormsToken() {
        const token = Utils.GetCookie("XSRF-TOKEN");

        if (token) {
            $("form").each((idx, elem) => {
                const $form = $(elem);

                if ($form.find("[name=__RequestVerificationToken]").length > 0) {
                    $form.find("[name=__RequestVerificationToken]").remove();
                }

                $form.append(`<input name="__RequestVerificationToken" type="hidden" value="${token}">`);
            });
        }
    }
}

const App = new Application();

$(() => {

    $.ajaxSetup({
        cache: false,
        beforeSend: function (xhr) {
            const token = Utils.GetCookie("XSRF-TOKEN");
            xhr.setRequestHeader(
                "RequestVerificationToken",
                token
            );
        }
    });

    WebAppUtils.InitGlobalUtils();

    WebAppUtils.InitInteractionComponents();

    WebAppUtils.SetMobileMenuButtonToggle();

    App.Init();
});